import { getOperationSetStepIds } from "../../../models/expapiunified/ExperimentOperationSet.model.js";
const authoringQueries = {
  /**
   * Gets the sets of experiment operations for a feature.
   */
  experimentOperationSetsByFeatureId: (featureId) => ({
    filter: `Feature/Id eq ${featureId}`
  }),
  /**
   * Gets the set of experiment operations for a progression.
   */
  experimentOperationSetsByProgressionId: (featureId, progressionId) => ({
    filter: `Feature/Id eq ${featureId} and ExperimentOperations/any(eo: eo/FromStep/Experiment/Progression/Id eq ${progressionId} or eo/ToStep/Experiment/Progression/Id eq ${progressionId})`
  }),
  /**
   * Gets the list of experiments for a progression.
   */
  experimentsByProgressionId: (progressionId) => ({
    filter: `Progression/Id eq ${progressionId}`
  }),
  /**
   * Gets the list of experiments referenced by an experiment operation set.
   */
  experimentsByExperimentOperationSet: (experimentOperationSet) => {
    const stepIds = getOperationSetStepIds(experimentOperationSet);
    return {
      filter: `Feature/Id eq ${experimentOperationSet.featureId} and ExperimentSteps/any(es: es/Id in (${stepIds.join(",")}))`
    };
  },
  /**
   * Gets the list of gates that reference a given experiment.
   */
  gatesByExperimentId: (featureId, experimentId) => ({
    filter: `ExperimentOperationSet/Feature/Id eq ${featureId} and ExperimentOperationSet/ExperimentOperations/any(eo: eo/FromExperiment/Id eq ${experimentId} or eo/ToExperiment/Id eq ${experimentId} or eo/FromStep/Experiment/Id eq ${experimentId} or eo/ToStep/Experiment/Id eq ${experimentId})`
  }),
  /**
   * Gets the list of gates that belong to a feature.
   */
  gatesByFeatureId: (featureId) => ({
    filter: `ExperimentOperationSet/Feature/Id eq ${featureId}`
  }),
  /**
   * Gets the list of gates that belong to a given progression.
   */
  gatesByProgressionId: (featureId, progressionId) => ({
    filter: `ExperimentOperationSet/Feature/Id eq ${featureId} and ExperimentOperationSet/ExperimentOperations/any(eo: eo/FromProgression/Id eq ${progressionId} or eo/ToProgression/Id eq ${progressionId} or eo/FromExperiment/Progression/Id eq ${progressionId} or eo/ToExperiment/Progression/Id eq ${progressionId} or eo/FromStep/Experiment/Progression/Id eq ${progressionId} or eo/ToStep/Experiment/Progression/Id eq ${progressionId})`
  }),
  /**
   * Gets the list of gate types referenced by gates within the given feature.
   */
  gateTypesByFeatureId: (featureId) => ({
    filter: `Gates/any(g: g/ExperimentOperationSet/Feature/Id eq ${featureId})`
  })
};
export {
  authoringQueries
};
//# sourceMappingURL=queries.js.map
